















import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'

@Component
export default class ScoreDisplay extends Vue {
  @Prop()
  private value!: string | number | null
  @Prop()
  private isPositive!: boolean
  @Prop()
  private isNegative!: boolean
  @Prop({ type: Boolean, default: false })
  private hidePlusSign!: boolean
  @Prop({ type: Number, default: 0 })
  private fractionalDigits!: number
}
